/** Emoji presets offered when creating a custom player counter. */
export const COUNTER_ICONS = ['☠️', '⚡', '🔥', '🩸', '☢️', '⭐', '💎', '👑', '⚔️', '🛡️'] as const;
